import { FaFileAlt, FaCreditCard, FaDownload, FaLifeRing} from "react-icons/fa";

const process = [
  {
    id: 1,
    icon: <FaFileAlt />,
    title: "Choose Your Template",
    content: "Browse our collection of modern HTML & React templates and pick the one that fits your project.",
  },
  {
    id: 2,
    icon: <FaCreditCard />,
    title: "Secure Payment",
    content: "Complete your purchase safely through Lemon Squeezy with a fast and secure checkout process.",
  },
  {
    id: 3,
    icon: <FaDownload />,
    title: "Instant Download",
    content: "After payment, you’ll receive an instant download link via email to access your template files.",
  },
  {
    id: 4,
    icon: <FaLifeRing />,
    title: "Ongoing Support",
    content: "Need help? We provide documentation and support to help you get started.",
  },
];

export default process;